var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Menu, Divider } from 'antd';
import './index.less';
export default function CustomMenu(props) {
    var _a = props.items, items = _a === void 0 ? [] : _a, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.itemClassName, itemClassName = _c === void 0 ? '' : _c, _d = props.showIcon, showIcon = _d === void 0 ? true : _d, _e = props.iconPosition, iconPosition = _e === void 0 ? 'left' : _e, onClickMenu = props.onClickMenu, styleObj = props.styleObj, restProps = __rest(props, ["items", "className", "itemClassName", "showIcon", "iconPosition", "onClickMenu", "styleObj"]);
    var renderMenuItem = function (item) {
        var key = item.key, label = item.label, icon = item.icon, disabled = item.disabled, onClick = item.onClick, clstag = item.clstag, hidden = item.hidden, dividerNode = item.dividerNode, isDivider = item.isDivider, active = item.active;
        if (hidden)
            return null;
        if (isDivider) {
            return dividerNode || React.createElement(Divider, { style: { margin: "0px", height: "1px", backgroundColor: "#E6E6E6", color: "#E6E6E6" } });
        }
        return (React.createElement(Menu.Item, { key: key, disabled: disabled, onClick: onClick, className: "custom-menu-item " + itemClassName + " " + (active && 'custom-menu-item-active') },
            React.createElement("div", { className: "custom-menu-item-content", "data-clstag": clstag },
                showIcon && icon && iconPosition === 'left' && (React.createElement("span", { className: "custom-menu-item-icon" }, icon)),
                React.createElement("span", { className: "custom-menu-item-label" }, label),
                showIcon && icon && iconPosition === 'right' && (React.createElement("span", { className: "custom-menu-item-icon" }, icon)))));
    };
    return (React.createElement(Menu, __assign({ id: 'custom-menu', className: "" + className, style: __assign({}, styleObj) }, restProps), items.map(renderMenuItem)));
}
;
//# sourceMappingURL=index.js.map